<div class="input-holder">
    <div class="wrapper">
        <input class="invisible-input"
               [value]="value"
               (input)="onInput($event)"
               (focus)="onFocus()"
               [disabled]="isDisabled"
               type="text"
               (blur)="onBlur()"
        />

        <div class="overlay">
        <span *ngFor="let c of overlayChars" class="input-char" [ngClass]="{'error': showError}">
              {{ c.trim().length === 0 ? '\u00A0' : c }}
        </span>
        <span *ngFor="let c of overlayPadding" class="placeholder-char" [ngClass]="{'error': showError}">
              {{ c.trim().length === 0 ? '\u00A0' : c }}
        </span>
        </div>
    </div>
</div>

